import { render, staticRenderFns } from "./QRCodePage.vue?vue&type=template&id=55cd6c2d&scoped=true"
import script from "./QRCodePage.vue?vue&type=script&lang=js"
export * from "./QRCodePage.vue?vue&type=script&lang=js"
import style0 from "./QRCodePage.vue?vue&type=style&index=0&id=55cd6c2d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55cd6c2d",
  null
  
)

export default component.exports